import React, { useState} from 'react'
import { IonPage, IonContent, useIonToast } from '@ionic/react';
import Gestion from 'src/services/gestionMarcacion';
import { Paper, Typography, Button, ButtonGroup, makeStyles, TextField } from '@material-ui/core'
import SaveIcon from '@material-ui/icons/Save';
import { closeOutline } from "ionicons/icons";
import { useHistory } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import HeaderGenerico from '../HeaderGenerico';
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';


const useStyles = makeStyles((theme) => ({
    root:{
      padding: '20px',
      alignContent: 'center',
      textAlign: 'center',
      margin: theme.spacing(2)
    },
    text: {
      color: 'white',
    },
    colorModal: {
      color: 'black',
      margin: theme.spacing(3),
    },
    button: {
      backgroundColor: '#900533',
      width: '96%',
      margin: theme.spacing(1),
    },
    buttonGroup: {
      alignContent: 'space-between',
      width: '100%',
      marginTop: '15px',
    
    },
    timePicker: {
        width: '100%',
        forcedColorAdjust: 'inherit'
    },
    paper: {
        width: '96%',
        alignContent: 'space-between',
        margin: theme.spacing(1),
    },
  }
  ));


  const motivoSupera = [
    {
      value: 'CP',
      label: 'Cubrio por falta de personal'
    },
    {
      value: 'HA',
      label: 'Hizo horas adicionales'
    },
    {
      value: 'CA',
      label: 'Corresponde asignacion'
    },
    {
      value: 'CR',
      label: 'Corresponde Remplazo'
    },
    {
      value: 'CO',
      label: 'Corresponde OS'
    },
  ]

export const GestionMarcacionSupera = ({info}) => {
    const datos = JSON.parse(info)
    const classes = useStyles();
    const [disabled, setDisabled] = useState(false);
    const [visibleGS, setVisibleGS] = useState(false);
    const [infoStatusGestionSalida, setInfoStatusGestionSalida] = useState('');
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState<any>('');
    const history = useHistory();
    const [present] = useIonToast();

      const { 
        nombre, 
        nroLegajo,
        fecha, 
        entrada,
        salida, 
        total, 
        idMarcacion, 
        entrada_id, 
        salida_id, 
        tipoMarcacion,
        tipoHora,
        nombrePServicio } = datos.info;


        
    const gestionarSupera = () => {

        const guardarSinSalida = {
            legajo:  nroLegajo,
            entrada: entrada,
            salida:  salida,
            total:  total,
            fecha:  fecha,
            tipoHora: tipoHora,
            comentario: `SUP- ${state}`,
            puntoServicio: nombrePServicio,
            entrada_id:  entrada_id,
            salida_id:  salida_id,
          }


          Gestion.guardarSupera(guardarSinSalida)
          .then((response) => {
              
                  if (response.status === 200) {
                      setDisabled(true);
                      setLoading(false);
                      setInfoStatusGestionSalida(response.data.info);
                      setVisibleGS(true);
                      setTimeout(() => {
                          setVisibleGS(false);
                          setDisabled(false);
                      }, 10000);
                      history.goBack()
                  } else if (response.status === 400) {
                      present({
                          message: response.data.error ? response.data.error : 'Error desconocido',
                          duration: 5000,
                      });
                      return;
                  }    
          })
        }

      const botonCerrar = {
        icono: closeOutline,
        action: () => history.goBack(),
      }

      const handleChangeOpciones = (event) => {
        console.log(event.target.value)
        const selectedMotivo = event.target.value;
        setState(selectedMotivo);
      };

  return (
    <IonPage>
    <HeaderGenerico textAlign='center' botonIzq={botonCerrar} titulo={`Gestion Marcacion Supera`} />
    
    <IonContent id="gestionMarcacionSupera">
    <Paper >
      <Typography>Operario: {nombre} </Typography>
      <Typography>Punto de Servicio: {nombrePServicio}</Typography>
      <Typography>Fecha: {fecha}</Typography>
      <Typography>Hora Entrada: {entrada}</Typography>
      <Typography>Hora Salida: {salida}</Typography>
      <Typography>Total de Horas: {total}</Typography>

        <TextField
        className={classes.root}
               id="solo"
               select
               required
               label="Motivo"
               value={state || ''}
               onChange={handleChangeOpciones}
               variant="outlined"
               style={{ width: '80%' }}
               >{motivoSupera.map((option) => (
                <option key={option.value} value={option.label}>
                  {option.label}
                </option>
              ))}
        </TextField>

      <ButtonGroup
        orientation='vertical'
        aria-label="vertical contained button group"
        className={classes.buttonGroup}
      >
        <Button variant="contained" disabled={disabled} onClick={gestionarSupera} className={classes.button}>
          <SaveIcon style={{color: 'white'}}/>
        </Button>
        
      <Button variant="contained" className={classes.button} onClick={() => history.goBack()}>
          <Typography className={classes.text}>Cancelar</Typography>
        </Button>

        </ButtonGroup>
      </Paper>

    <div className={classes.root}>
    {visibleGS ? (<>
        <DoneAllOutlinedIcon style={{fontSize: '100px', color: '#900533'}}/>
        <Typography style={{fontSize: '20px'}}>{`${infoStatusGestionSalida}`}</Typography>
        </>
    ) : loading ? (
    <div>
    <Skeleton />
    <Skeleton animation={false} />
    <Skeleton animation="wave" />
  </div>
  ) : null }
  </div>
  
    </IonContent>
  </IonPage>
);
};


